<template src="./Shared/template.html" />
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/marble.webp');

  .promotion__row--0 {
    font-size: var(--font-size-xxxxl);
    line-height: var(--font-size-xxxxl);
    margin-bottom: 0.5rem;

    @media (max-width: $breakpoint-mobile) {
      font-size: var(--font-size-xxl);
      line-height: var(--font-size-xxl);
    }
  }

  &__row--2,
  &__row--1 {
    background-color: var(--black);
    color: var(--white);
    font-size: var(--font-size-xxl);
    line-height: var(--font-size-xxl);
    padding: var(--spacing) calc(var(--spacing ) * 2);

    @media (max-width: $breakpoint-mobile) {
      font-size: var(--font-size-xl);
      line-height: var(--font-size-xl);
    }
  }

  &__row--2 {
    background-color: var(--white);
    color: var(--black);
    font-size: var(--font-size-l);
    line-height: var(--font-size-l);
    padding: calc(var(--spacing) * 0.5) var(--spacing);
  }
}
</style>
